// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + (chunkId === 347 ? "secondary" : chunkId) + "." + {"20":"7065990b89ddddd25d2e","347":"025143bf1fa822a4723c","724":"6242dc2074094e0ef90a"}[chunkId] + ".js";
};